import { TypeLieu } from './TypeLieu';
import { TypeObjCPV } from './TypeObjCPV';
import { TypeFournitures } from './TypeFournitures';
import { TypeTravaux } from './TypeTravaux';
import { TypeDescNatureMarcheDivers } from './TypeDescNatureMarcheDivers';
import { ChampsLibresTexte } from './ChampsLibresTexte';

export class Description {

  public marcheTravaux: TypeTravaux;

  public lieuExecution: TypeLieu;

  public lieuExecutionLivraison: TypeLieu;

  public marcheServices: string;

  public cpv: TypeObjCPV;

  public marcheFournitures: TypeFournitures;

  public objet: ChampsLibresTexte;

  public lieuLivraison: TypeLieu;

  public descriptionMarche: TypeDescNatureMarcheDivers;

  public isLieuExecutionLivraison: boolean;

  constructor() {
    this.marcheTravaux = new TypeTravaux();
    this.lieuExecution = new TypeLieu();
    this.lieuExecutionLivraison = new TypeLieu();
    this.marcheServices = '';
    this.cpv = new TypeObjCPV();
    this.marcheFournitures = new TypeFournitures();
    this.objet = new ChampsLibresTexte();
    this.lieuLivraison = new TypeLieu();
    this.descriptionMarche = new TypeDescNatureMarcheDivers();
    this.isLieuExecutionLivraison = true;

  }
}
